// Autogenerated
// -------------
// gulpfile.js --> generateBuildInfo

export const Build = {
    version: "6.22.59 (369b0c55d7a015a0b9d55b40d6bc6ec9)",
    jsVersion: "6efa376026bd0223329d83c7ab4b944ad723c772",
    wasmJsSize:  174450,
    wasmVersion: "a77a550946416473583d331c3b067257",
    wasmSize: 1375783,
    buildSeed:  1588436840119,
};
